<p-panel [id]="config.id" [toggleable]="true">
  <ng-template *ngIf="config.name" pTemplate="header">
    <div class="flex align-items-center gap-2">
      <span class="font-bold"> {{ config.name }}</span>
      <ng-container *ngIf="headerTemplate" [ngTemplateOutlet]="headerTemplate"></ng-container>
    </div>
  </ng-template>
  <div class="grid">
    <container-element
      *ngFor="let component of config.viewComponents"
      [ngSwitch]="getComponentType(component)"
      [class]="getColumnClass()"
    >
      <eo-text
        *ngSwitchCase="EoViewComponentTypeEnum.TEXT"
        [label]="getComponentLabel(component)"
        [value]="getComponentValue(component)"
      ></eo-text>
      <eo-date
        *ngSwitchCase="EoViewComponentTypeEnum.DATE"
        [label]="getComponentLabel(component)"
        [value]="getComponentValue(component)"
        [dateFormat]="getComponentDateFormat(component)"
      ></eo-date>
      <eo-label
        *ngSwitchCase="EoViewComponentTypeEnum.LABEL"
        [label]="getComponentLabel(component)"
        [value]="getComponentValue(component)"
        [toolTipPosition]="getComponentToolTipPosition(component)"
        [toolTipText]="getComponentToolTipText(component)"
        [icon]="getComponentIcon(component)"
        [severity]="getComponentSeverity(component)"
      ></eo-label>
      <eo-currency
        *ngSwitchCase="EoViewComponentTypeEnum.CURRENCY"
        [label]="getComponentLabel(component)"
        [value]="getComponentValue(component)"
        [decimalDigits]="getComponentDecimalDigits(component)"
        [currencyFormat]="getComponentCurrencyFormat(component)"
      ></eo-currency>
    </container-element>
  </div>
</p-panel>